import { FC } from 'react'

import { FieldProps, FormInputProps } from 'brief-form'
import { Questionnaire } from 'commons/types/DTO/bank/quarterlyReport/questionnaire'
import { TextareaInput } from 'ui/components/InputV2'
import { Col2x, FormRow } from 'ui/themes/globalStyles'

import { SecondText } from '../../style'

type ReviewCommentsProps = {
  Field: <Input extends React.ComponentType<FormInputProps<any, any>>>(
    props: FieldProps<Input, Questionnaire>
  ) => JSX.Element
}

export const ReviewComments: FC<ReviewCommentsProps> = ({ Field }) => (
  <>
    <SecondText>
      <i>Review Comments:</i>
    </SecondText>
    <FormRow>
      <Col2x>
        <Field
          name="reviewCommentsNotes"
          label=""
          input={TextareaInput}
          inputProps={{
            maxLength: 5000
          }}
        />
      </Col2x>
    </FormRow>
  </>
)
